export default __webpack_public_path__ + "static/media/is.35a1333a.jpg";